import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FocusInputType, KeyValues5, KeyValues5Sets, LocalService, NumericConfig, Status } from '../../../service/local.service';
import { SellerManagementService } from 'src/service/seller-management.service';

@Component({
  selector: 'app-supporting-lines',
  templateUrl: './supporting-lines.component.html',
  styleUrls: ['./supporting-lines.component.scss']
})
export class SupportingLinesComponent implements OnInit {
  @Input() items; @Input() IsNumber = false; @Input() maxValue = null; @Input() isNegativeAllowed = true;
  numericConfig: NumericConfig = { isDecimalAllowed: true } as NumericConfig;
  columnSlot: number = 12; @Input() isBoxRequired = true;
  @Input() businessTaxCategories: KeyValues5[] = []; @Input() selectedBusinessTaxCategory: string = '';
  @Input() businessTaxes: KeyValues5Sets[] = []; @Input() countryCode: string = ''; @Input() businessId: string = '';

  @Output() itemsChange = new EventEmitter<any>();
  @Output() businessTaxesChange = new EventEmitter<any>();
  @Output() onSelectedBusinessTaxCategoryChange = new EventEmitter<string>();

  htmlId: string = ''; elementIds: any;
  constructor(public localService: LocalService, private sellerManagementService: SellerManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      tax_name: 'tax_name_' + this.htmlId
    };
  }

  ngOnInit(): void {
    // if (this.IsNumber) {
    //   this.columnSlot = 12 / this.items.length;
    // }

    this.onSetBusinessCategory();
    this.numericConfig.maxValue = this.maxValue;
    this.numericConfig.isNegativeAllowed = this.isNegativeAllowed;
  }

  ngOnChanges(): void {
  }

  onSetBusinessCategory() {
    if (!(this.selectedBusinessTaxCategory && this.selectedBusinessTaxCategory.length > 0) && this.businessTaxCategories && this.businessTaxCategories.length > 0) {
      this.selectedBusinessTaxCategory = this.businessTaxCategories.find(x => x.v3 == '1')?.key;
    }
    if (!(this.selectedBusinessTaxCategory && this.selectedBusinessTaxCategory.length > 0) && this.businessTaxes && this.businessTaxes.length > 0) {
      this.selectedBusinessTaxCategory = this.businessTaxes[0].key;
    }
    this.onSelectBusinessTax();
  }

  onSelectBusinessTax(selectedBusinessTaxCategory?: string) {
    if (selectedBusinessTaxCategory) {
      this.selectedBusinessTaxCategory = selectedBusinessTaxCategory;
    }
    if (this.businessTaxes && this.businessTaxes.length > 0) {
      this.items = this.businessTaxes.find(x => x.key == this.selectedBusinessTaxCategory)?.values ?? [];
      if (selectedBusinessTaxCategory) {
        this.onValueUpdate();
        this.onResetTax();
      }
    }
  }

  isAdd = false; isEdit = false; taxName = '';
  onAction(actionType: number) {
    switch (actionType) {
      case 1: {
        this.onResetTax();
        this.taxName = this.businessTaxCategories.find(x => x.key == this.selectedBusinessTaxCategory).v1;
        this.isEdit = true;
        this.localService.onFocusNextInput(this.elementIds.tax_name, FocusInputType.TextBox);
      } break;
      case 2: {
        this.onResetTax();
        this.isAdd = true;
        this.localService.onFocusNextInput(this.elementIds.tax_name, FocusInputType.TextBox);
      } break;
      case 3: {
        this.onResetTax();
      } break;
      case 4: {
        this.onSaveTax();
      } break;
      default:
        break;
    }
  }

  onResetTax() {
    this.isAdd = false;
    this.isEdit = false;
    this.taxName = '';
  }

  onSaveTax() {
    const data = {
      key: this.isAdd ? '' : this.selectedBusinessTaxCategory,
      v1: this.businessId,
      v2: this.taxName
    } as KeyValues5;
    this.sellerManagementService.saveBusinessTaxCategory(this.localService.getLoginAsCountryCode() , data).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status === Status.Success) {
        this.selectedBusinessTaxCategory = result.id;
        this.onLoadTax(result.id);
      }
    });
  }

  onLoadTax(selectedBusinessTaxCategory: string) {
    this.sellerManagementService.getBusinessTaxCategories(this.localService.getLoginAsCountryCode() , this.businessId).subscribe(result => {
      this.businessTaxCategories = result;
      if (this.isAdd) {
        this.onLoadTaxDetails(selectedBusinessTaxCategory);
      } else {
        this.onSelectBusinessTax(selectedBusinessTaxCategory);
      }
    });
  }

  onLoadTaxDetails(selectedBusinessTaxCategory: string) {
    this.sellerManagementService.getBusinessTaxesFull(this.localService.getLoginAsCountryCode() , this.businessId).subscribe(result => {
      const taxes = result.find(x => x.key == selectedBusinessTaxCategory);
      this.businessTaxes.push({
        key: selectedBusinessTaxCategory,
        values: taxes ? taxes.values : []
      } as KeyValues5Sets);
      this.onSelectBusinessTax(selectedBusinessTaxCategory);
    });
  }

  onValueUpdate() {
    if (this.businessTaxes && this.businessTaxes.length > 0) {
      let businessTax = this.businessTaxes.find(x => x.key === this.selectedBusinessTaxCategory);
      if (businessTax) {
        businessTax.values = this.items;
      }
    }
  }
}
